import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b3d0d6a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1b3d0d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d0d6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3d0d6a')) {
      api.createRecord('1b3d0d6a', component.options)
    } else {
      api.reload('1b3d0d6a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1b3d0d6a&scoped=true&", function () {
      api.rerender('1b3d0d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/mwbj/index.vue"
export default component.exports